module.exports = __webpack_public_path__ + "static/media/logo.160b46d0.png";